import AllOrders from '../allOrders/AllOrders';

import './allParcels.scss';

const AllParcels = () => {
	return <AllOrders admin title='All Parcels' isRejected={false} />;
};

export default AllParcels;
